var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" If you would like to learn more about limits, credit and collateral "),_c('a',{staticClass:"plain-color-link",attrs:{"href":"https://www.alt21.com/account-limits-requirements/","target":"_blank"}},[_vm._v("click here")]),_vm._v(". ")])
}]

export { render, staticRenderFns }